import { Http, Url } from '@intelipost-js/secure-providers';

export default {
  getAllLogs(context, filters = {}) {
    const {
      searchBy = 'all',
      searchParam = null,
    } = filters;

    const pathParams = [
      searchBy,
      searchParam,
    ];

    context.commit('setLoading', true);

    return Http.get(Url.toQueryString('api/v1/elasticsearch', null, pathParams))
      .then((res) => {
        context.commit('setLogs', res.data.content);
        context.commit('setLoading', false);
        return res;
      })
      .catch((err) => {
        context.commit('setLoading', false);
        throw err;
      });
  },
  getErrorLogs(context, filters = {}) {
    const {
      searchBy = 'all',
      searchParam = null,
    } = filters;

    const params = { status: 'error' };
    const pathParams = [
      searchBy,
      searchParam,
    ];

    context.commit('setLoading', true);

    return Http.get(Url.toQueryString('api/v1/elasticsearch', params, pathParams))
      .then((res) => {
        context.commit('setErrorLogs', res.data.content);
        context.commit('setLoading', false);
        return res;
      }).catch((err) => {
        context.commit('setLoading', false);
        throw err;
      });
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-analytic/features/logs/pages/api/store/actions.js